import { useEffect, useRef } from 'react';

/**
 * Preserves the last non-undefined value.
 * Useful for exit animations where you need to keep showing data
 * while a component animates out.
 *
 * @param value - The current value (may be undefined)
 * @returns The current value if defined, otherwise the last defined value
 */
export function usePreservedValue<T>(value: T | undefined): T | undefined {
  const preservedRef = useRef<T | undefined>(value);

  useEffect(() => {
    if (value !== undefined) {
      preservedRef.current = value;
    }
  }, [value]);

  // Valid in this case, we don't need the value to be reactive as the source is reactive
  // eslint-disable-next-line react-hooks/refs
  return value ?? preservedRef.current;
}
